import React from 'react'
import img2 from "../assets/images/blog/9.png"
import img3 from "../assets/images/blog/7.png"
import img1 from "../assets/images/blog/4.png"
import img5 from "../assets/images/blog/1.png"
import img6 from "../assets/images/blog/6.png"
import img7 from "../assets/images/blog/2.png"
import img8 from "../assets/images/blog/8.png"
import img9 from "../assets/images/blog/9.png"
import img10 from "../assets/images/blog/10.png"
import { Link } from 'react-router-dom'
import Squaretwo from './Squaretwo'

export default function Article() {
    return (
        <div>
            <section className="section bg-gradient-new pricing" id="pricing">
                <div className="bg-shape" />
                <div className="container">
                    <div className="row gy-5 justify-content-center mt-4" >
                        <div className="col-lg-10">
                            <div className="text-center">

                                <p className="articleheading">Lastest articles about headshot photography</p>
                                <p className="articledesc">Insights, ideas and inspiration for headshot photography</p>
                                <Link className=" btn btn-primary nav-btn mt-2"
                                    style={{ fontFamily: "Poppins", fontWeight: "700", borderRadius: "12px", fontSize: "20px" }}
                                    to="#" >CREATE YOURS NOW </Link>

                            </div>
                        </div>
                    </div>


                    <div className='row mt-3'>
                        <div className='col-md-12 d-flex justify-content-between'>
                            <Link to="/">
                                <div className="post">
                                    <spna className="abcc">
                                        All Posts
                                    </spna>
                                </div>
                            </Link>
                            <Link to="/Login">
                                <div className="abc">
                                    <spna className="abcc">
                                        Login/Sign up

                                    </spna>
                                </div>
                            </Link>



                        </div>
                    </div>

                    <div className="row gy-5 justify-content-center mt-2">

                        <div className="col-lg-4 col-md-6">

                            <div className=" pricebg h-100 ">
                                <div className=" text-center mt-3">

                                    <img src={img1} alt='' style={{ width: "90%" }} />
                                </div>
                                <div className="d-flex align-items-center justify-content-around mt-3">
                                    <div className="articlebtn">
                                        <spna className="articlebtnin">
                                            <Link className="  mx-1" to="">
                                                Product Update
                                            </Link>
                                        </spna>
                                    </div>
                                    <p> june 13,</p>
                                </div>

                                <div className=" m-3">

                                    {/* <h5>Upload your selfies</h5> */}
                                    <p className="articlecard">Picture-Perfect: Choosing the Right Dimensions for Professional Headshots</p>
                                </div>
                            </div>

                        </div>

                        <div className="col-lg-4 col-md-6">
                            <div className="pricebg h-100  ">
                                <div className="text-center mt-3">
                                    <img src={img3} alt='' style={{ width: "90%" }} />

                                </div>
                                <div className="d-flex align-items-center justify-content-around mt-3">
                                    <div className="articlebtn">
                                        <spna className="articlebtnin">
                                            <Link className="  mx-1" to="">
                                                Product Update
                                            </Link>
                                        </spna>
                                    </div>
                                    <p> june 13,</p>

                                </div>

                                <div className="m-3">

                                    <p className="articlecard">professional Outdoor Headshots for a Unique Look.</p>
                                </div>
                            </div>

                        </div>

                        <div className="col-lg-4 col-md-6">
                            <div className="pricebg h-100  ">
                                <div className="text-center mt-3">
                                    <img src={img2} alt='' style={{ width: "90%" }} />

                                </div>
                                <div className="d-flex align-items-center justify-content-around mt-3">
                                    <div className="articlebtn">
                                        <spna className="articlebtnin">
                                            <Link className="  mx-1" to="">
                                                Product Update
                                            </Link>
                                        </spna>
                                    </div>
                                    <p> june 13,</p>

                                </div>

                                <div className=" m-3">

                                    <p className="articlecard">Embracing Modern Professional Headshots: Tips for a Contemporary Look.</p>
                                </div>
                            </div>

                        </div>

                    </div>
                    <div className="row gy-5 justify-content-center mt-2">

                        <div className="col-lg-4 col-md-6">

                            <div className="pricebg h-100 ">
                                <div className=" text-center mt-3">

                                    <img src={img5} alt='' style={{ width: "90%" }} />
                                </div>
                                <div className="d-flex align-items-center justify-content-around mt-3">
                                    <div className="articlebtn">
                                        <spna className="articlebtnin">
                                            <Link className="  mx-1" to="">
                                                Product Update
                                            </Link>
                                        </spna>
                                    </div>
                                    <p> june 13,</p>

                                </div>

                                <div className=" m-2">
                                    {/* <h5>Upload your selfies</h5> */}
                                    <p className="articlecard">Navigating Virtual Professional Headshots.</p>
                                </div>
                            </div>

                        </div>

                        <div className="col-lg-4 col-md-6">
                            <div className="pricebg h-100   ">
                                <div className="text-center mt-3">
                                    <img src={img6} alt='' style={{ width: "90%" }} />

                                </div>
                                <div className="d-flex align-items-center justify-content-around mt-3">
                                    <div className="articlebtn">
                                        <spna className="articlebtnin">
                                            <Link className="  mx-1" to="">
                                                Product Update
                                            </Link>
                                        </spna>
                                    </div>
                                    <p> june 13,</p>

                                </div>

                                <div className="m-2">

                                    <p className="articlecard">professional Outdoor Headshots for a Unique Look.</p>
                                </div>
                            </div>

                        </div>

                        <div className="col-lg-4 col-md-6">
                            <div className="pricebg h-100 ">
                                <div className="text-center mt-3">
                                    <img src={img7} alt='' style={{ width: "90%" }} />

                                </div>
                                <div className="d-flex align-items-center justify-content-around mt-3">
                                    <div className="articlebtn">
                                        <spna className="articlebtnin">
                                            <Link className="  mx-1" to="">
                                                Product Update
                                            </Link>
                                        </spna>
                                    </div>
                                    <p> june 13,</p>

                                </div>

                                <div className=" m-2">

                                    <p className="articlecard">Embracing Modern Professional Headshots: Tips for a Contemporary Look.</p>
                                </div>
                            </div>

                        </div>

                    </div>
                    <div className="row gy-5 justify-content-center mt-2">

                        <div className="col-lg-4 col-md-6">

                            <div className="pricebg h-100 ">
                                <div className=" text-center mt-3">

                                    <img src={img8} alt='' style={{ width: "90%" }} />
                                </div>
                                <div className="d-flex align-items-center justify-content-around mt-3">
                                    <div className="articlebtn">
                                        <spna className="articlebtnin">
                                            <Link className="  mx-1" to="">
                                                Product Update
                                            </Link>
                                        </spna>
                                    </div>
                                    <p> june 13,</p>

                                </div>

                                <div className=" m-2">
                                    {/* <h5>Upload your selfies</h5> */}
                                    <p className="articlecard">Navigating Virtual Professional Headshots.</p>
                                </div>
                            </div>

                        </div>

                        <div className="col-lg-4 col-md-6">
                            <div className="pricebg h-100  ">
                                <div className="text-center mt-3">
                                    <img src={img9} alt='' style={{ width: "90%" }} />

                                </div>
                                <div className="d-flex align-items-center justify-content-around mt-3">
                                    <div className="articlebtn">
                                        <spna className="articlebtnin">
                                            <Link className="  mx-1" to="">
                                                Product Update
                                            </Link>
                                        </spna>
                                    </div>
                                    <p> june 13,</p>

                                </div>

                                <div className="m-2">

                                    <p className="articlecard">professional Outdoor Headshots for a Unique Look.</p>
                                </div>
                            </div>

                        </div>

                        <div className="col-lg-4 col-md-6">
                            <div className="pricebg h-100  ">
                                <div className="text-center mt-3">
                                    <img src={img10} alt='' style={{ width: "90%" }} />

                                </div>
                                <div className="d-flex align-items-center justify-content-around mt-3">
                                    <div className="articlebtn">
                                        <spna className="articlebtnin">
                                            <Link className="  mx-1" to="">
                                                Product Update
                                            </Link>
                                        </spna>
                                    </div>
                                    <p> june 13,</p>

                                </div>

                                <div className=" m-2">

                                    <p className="articlecard">Embracing Modern Professional Headshots: Tips for a Contemporary Look.</p>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div className='row mt-3'>
                        <div className='col-md-12 d-flex justify-content-center'>
                            <div className="abcpag">
                                <spna className="abccpg">
                                    <Link to="/">
                                        1
                                    </Link>
                                </spna>
                            </div>

                            <div className="post">
                                <spna className="abccccc">
                                    2 3 ... 12
                                </spna>
                            </div>
                            <Link to="/">
                                <div className="abcpag">
                                    <spna className="abccpg">
                                        Next

                                    </spna>
                                </div>
                            </Link>



                        </div>
                    </div>

                </div>
                {/* End container */}
            </section>
            <Squaretwo />

        </div>
    )
}
